<div id="cd_{{chartId}}" class="chartdivTmp" ></div>
